import React from 'react';
import { keyframes } from '@emotion/react';
import Color, { colors } from '../colors';
import { borderRadius } from '../tokens';

/*
* Will conditionally render a skeleton if no children exist inside.
* */

interface SkeletonProps extends Omit<HtmlPropsNoRef<HTMLDivElement>, 'as'> {
    isButton?: boolean
    backgroundColor?: keyof typeof colors
}
const Skeleton = ({ children, isButton, backgroundColor, color, ...props }: SkeletonProps): JSX.Element => {
    const pulseKeyframes = keyframes({
        '50%': {
            opacity: '0.5',
        },
    });

    const hasChildren = React.Children.toArray(children).filter(x => !!x).length > 0;

    return (
        <div>
            {!hasChildren && (
                <Color
                    backgroundColor={backgroundColor || 'grey300'}
                    role="region"
                    aria-busy="true"
                    css={{
                        minHeight: '12px',
                        width: '100%',
                        animation: `${pulseKeyframes} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite`,
                        borderRadius: isButton ? borderRadius.full : borderRadius.small,
                    }}
                    {...props}
                    dangerouslySetInnerHTML={{
                        __html: '&nbsp;',
                    }}
                />
            )}
            {hasChildren && children}
        </div>
    );
};

export default Skeleton;
